/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".accent-color[_ngcontent-%COMP%]{color:#555}.warn-color[_ngcontent-%COMP%]{color:#f44336}.nameUnit[_ngcontent-%COMP%]{color:#555}@media only screen and (min-width:300px) and (max-width:768px){.nameUnit[_ngcontent-%COMP%]{color:#fff!important}}.defaultFont[_ngcontent-%COMP%]    {padding-left:30px;margin:5px 0;color:#aaaab0;font-size:18px}"];
export { styles as styles };
